export default __webpack_public_path__ + "static/media/shop.326b40d7.svg";